import { Controller } from 'stimulus';
import { fileMatchesAccept } from '../../util';

// Previews a picked profile photo in the Personal Info card. The photo itself is only sent
// when the card's form is saved.
export default class extends Controller {
  static targets = ['input', 'removeInput', 'image', 'placeholder', 'removeButton', 'error'];

  static values = {
    hasSavedAvatar: Boolean,
    maxFileSize: Number,
    typeError: String,
    sizeError: String,
  };

  browse() {
    this.inputTarget.click();
  }

  selected() {
    const file = this.inputTarget.files[0];
    if (!file) {
      return;
    }
    const error = this.#fileError(file);
    if (error) {
      this.errorTarget.textContent = error;
      this.errorTarget.classList.remove('hidden');
      this.inputTarget.value = '';
      return;
    }
    this.errorTarget.classList.add('hidden');
    this.removeInputTarget.value = '0';
    const reader = new FileReader();
    reader.onload = (event) => this.#show(event.target.result);
    reader.readAsDataURL(file);
  }

  remove() {
    this.inputTarget.value = '';
    this.removeInputTarget.value = this.hasSavedAvatarValue ? '1' : '0';
    this.errorTarget.classList.add('hidden');
    this.#show(null);
    // Neither change above fires an input event, so the dirty-form check has to be told.
    this.dispatch('changed');
  }

  #fileError(file) {
    if (!fileMatchesAccept(file, this.inputTarget.accept)) {
      return this.typeErrorValue;
    }
    if (file.size > this.maxFileSizeValue) {
      return this.sizeErrorValue;
    }
    return null;
  }

  #show(src) {
    if (src) {
      this.imageTarget.src = src;
    }
    this.imageTarget.classList.toggle('hidden', !src);
    this.placeholderTarget.classList.toggle('hidden', Boolean(src));
    this.removeButtonTarget.classList.toggle('hidden', !src);
  }
}
